let SalaryCap = {
    SALARY_CAP_SET_INNER: 'SALARY_CAP_SET_INNER',
    SALARY_CAP_SET_OUTER: 'SALARY_CAP_SET_OUTER',

    DEFAULT_VALUE_FOR_MAX_SALARY_CAP: 50000,
    DEFAULT_VALUE_FOR_MIN_SALARY_CAP: 0,
};

export default SalaryCap;
